import { Block, BlockContent, BlockImage, BlockTitle } from '../Block';
import {
  Century,
  CenturyLabel,
  CenturyWrapper,
  ImageWrapper,
  TitleContent,
  WrapperAudioPlayer
} from './styles';
import React, { useEffect, useState } from 'react';

import AudioPlayer from '../AudioPlayer/AudioPlayer';
import Container from '../Grid/Container';
import IconSVG from '../Icon/IconSVG';
import PropTypes from 'prop-types';
import Text from '../Typography/Text';
import { Title } from '../common/styles';
import { media } from '../../styles/media';
import styled from 'styled-components';
import theme from '../../theme';
import { translate } from 'react-i18next';
import useMobile from '../../utils/useMobile';

const Wrapper = styled.div`
  padding-top: 87px;
  padding-bottom: 127px;

  ${media.tablet`
    padding-top: 71px;
    padding-bottom: 83px;
  `};
`;

const AudioGuide = ({ data, t }) => {
  const { isMobile } = useMobile();
  if (!data?.guide?.detail) return null;

  const image = isMobile
    ? data.guide.img_header_mobile || data.guide.img_header_desktop
    : data.guide.img_header_desktop || data.guide.img_header_mobile;

  return (
    <Block>
      {data.guide.detail.title && (
        <BlockTitle>{data.guide.detail.title}</BlockTitle>
      )}
      <ImageWrapper>
        <BlockImage src={image} height={isMobile ? 200 : 400} />
        {data.guide.detail.century_1 && (
          <CenturyWrapper>
            <Century>{data.guide.detail.century_1}</Century>
            <CenturyLabel>{t('audio_guide.century_label')}</CenturyLabel>
          </CenturyWrapper>
        )}
      </ImageWrapper>

      <WrapperAudioPlayer>
        <AudioPlayer url={data.guide.detail.file_audio_guide} />
      </WrapperAudioPlayer>
      <TitleContent>
        <Text variant="heading4">
          <IconSVG mr={10} name={'keynote'} />
          {data.guide.type === 'court'
            ? t(`audio_guide.type.court`)
            : t(`audio_guide.type.portraits`)}{' '}
          / {data.guide?.detail?.medallion_title}
        </Text>
      </TitleContent>
      {data.guide.detail.content && (
        <BlockContent wysiwyg showMore>
          {data.guide.detail.content}
        </BlockContent>
      )}
    </Block>
  );
};

AudioGuide.propTypes = {
  title: PropTypes.string
};

export default translate()(AudioGuide);
